import { render, staticRenderFns } from "./PermissionsCustomFieldsForm.vue?vue&type=template&id=64001caa&scoped=true&"
import script from "./PermissionsCustomFieldsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsCustomFieldsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64001caa",
  null
  
)

export default component.exports